import {
  type DSLValueLegacy,
  type StudyPeriodRestrictionsLegacy,
} from '@verantos-dev/types-cohorts';

import { getDSLDateForDateValue } from '../utils/getDSLDateForDateValue';

export const transformStudyPeriodRestrictionsToDsl = (
  studyPeriodRestrictions?: StudyPeriodRestrictionsLegacy
): DSLValueLegacy[] => {
  if (!studyPeriodRestrictions) {
    return [];
  }

  const studyPeriodRestrictionsArray: DSLValueLegacy[] = [];
  const { overallStudyPeriodRestriction, baselinePeriodRestriction, followUpPeriodRestriction } =
    studyPeriodRestrictions;

  if (overallStudyPeriodRestriction && overallStudyPeriodRestriction.isEnabled) {
    studyPeriodRestrictionsArray.push({
      id: 'overallStudyPeriodRestriction',
      value: `STUDY_PERIOD ( ${
        overallStudyPeriodRestriction.startDate
          ? getDSLDateForDateValue(overallStudyPeriodRestriction.startDate)
          : ''
      } , ${
        overallStudyPeriodRestriction.endDate
          ? getDSLDateForDateValue(overallStudyPeriodRestriction.endDate)
          : ''
      } ) ;`,
    });
  }

  if (baselinePeriodRestriction && baselinePeriodRestriction.isEnabled) {
    studyPeriodRestrictionsArray.push({
      id: 'baselinePeriodRestriction',
      value: `BASELINE ( ${baselinePeriodRestriction.daysBeforeIndexDate ?? ''} ) ;`,
    });
  }

  if (followUpPeriodRestriction && followUpPeriodRestriction.isEnabled) {
    studyPeriodRestrictionsArray.push({
      id: 'followUpPeriodRestriction',
      value: `FOLLOW_UP ( ${followUpPeriodRestriction.daysAfterIndexDate ?? ''} ) ;`,
    });
  }

  return studyPeriodRestrictionsArray;
};
